import { Component, ElementRef, OnInit, ViewChild, ChangeDetectorRef, Renderer2, Inject } from '@angular/core';
import { CommonModule, DOCUMENT } from '@angular/common';
import { ActivatedRoute, Router, RouterLink } from '@angular/router';
import { DomSanitizer, SafeHtml } from '@angular/platform-browser';
import { MatDialog } from '@angular/material/dialog';
import { AppConstants } from 'src/app/app.constants';
import { ProductService } from 'src/_lib/service/product.service';
import { CommunicationService } from 'src/_lib/service/communication.service';
import { LoveItPopupComponent } from 'src/app/templates/featured-product/component/product-details/love-it-popup/love-it-popup.component';
import { WishlistPopupComponent } from './wishlist-popup/wishlist-popup.component';
import { environment } from 'src/environments/environment.prod';
import { wishlistPostDataInterface } from 'src/_lib/interfaces/request-interfaces/wishlist-popup.interface';
import { CartService } from 'src/_lib/service/cart.service';
import { CommanpageService } from 'src/_lib/service/commanpages.service';
import { skuSlugPostDataInterface } from 'src/_lib/interfaces/request-interfaces/product.interface';
import { ProductOptionErrorpopupComponent } from './product-option/component/product-option-errorpopup/product-option-errorpopup.component';
import { SearchByVehicleComponent } from 'src/app/templates/search-by-vehicle/search-by-vehicle.component';
import { SearchByVehicleService } from 'src/_lib/service/search-by-vehicle.service';
import { SubscribeComponent } from 'src/app/templates/subscribe/subscribe.component';
import { ProductReviewComponent } from 'src/app/templates/featured-product/component/product-review/product-review.component';
import { GallaryPhotosComponent } from 'src/app/templates/featured-product/component/gallary-photos/gallary-photos.component';
import { InstructionsComponent } from 'src/app/templates/featured-product/component/instructions/instructions.component';
import { FaqsComponent } from 'src/app/templates/featured-product/component/faqs/faqs.component';
import { NgIf, NgFor, NgSwitch, NgSwitchCase, SlicePipe, Location, NgClass } from '@angular/common';
import { ProductSpecificationsComponent } from "./product-specifications/product-specifications.component";
import { AffirmWidgetComponent } from "src/app/templates/featured-product/component/affirm-widget/affirm-widget.component";
import { ApplicationComponent } from 'src/app/templates/featured-product/component/application/application.component';
import { StarArrayPipe } from 'src/_lib/pipes/star-array.pipe';
import { SpinnerComponent } from "src/app/templates/spinner/spinner.component";
import { ProductOptionComponent } from "./product-option/product-option.component";
import { ProductColorSizeComponent } from "./product-color-size/product-color-size.component";
import { RecentlyViewedComponent } from 'src/app/templates/featured-product/component/recently-viewed/recently-viewed.component';
import { RelatedProductsComponent } from 'src/app/templates/featured-product/component/related-products/related-products.component';
import { ReviewItPopupComponent } from './review-it-popup/review-it-popup.component';
import { SeoService } from 'src/_lib/service/seo.service';
import { BreadcrumbComponent } from 'src/app/templates/breadcrumb/breadcrumb.component';
import { CheckFitmentComponent } from "./check-fitment/check-fitment.component";
import { combineLatest, firstValueFrom } from 'rxjs';
import { PaypalWidgetComponent } from 'src/app/templates/featured-product/component/paypal-widget/paypal-widget.component';
import { CustomCurrencyPipe } from 'src/_lib/pipes/customCurrency.pipe';
import { WarrantyComponent } from "../warranty/warranty.component";
import { TruncateHtmlPipe } from 'src/_lib/pipes/truncate-html.pipe';
import { GtmService } from 'src/_lib/service/gtm.service';
import { ReactiveFormsModule, FormBuilder, FormGroup, Validators } from '@angular/forms';
import { WebinfoService } from 'src/_lib/service/webinfo.service';
import { SubscribePopupComponent } from 'src/app/templates/subscribe/subscribe-popup/subscribe-popup.component';
import { SanitizeHtmlPipe } from 'src/_lib/pipes/sanitizeHtml';
import { CartVerifyPopupComponent } from 'src/app/templates/cart/component/cart-verify-popup/cart-verify-popup.component';
import { CategoryService } from 'src/_lib/service/category.service';
import { ProductResourcesComponent } from '../product-resources/product-resources.component';
import { FooterService } from 'src/_lib/service/footer.service';
import { BrowserService } from 'src/_lib/service/browser.service';

@Component({
  selector: 'app-product-details',
  templateUrl: './product-details.component.html',
  styleUrls: ['./product-details.component.scss'],
  standalone: true,
  imports: [
    CommonModule,
    NgIf,
    NgFor,
    NgClass,
    NgSwitch,
    NgSwitchCase,
    SlicePipe,
    RouterLink,
    InstructionsComponent,
    GallaryPhotosComponent,
    RecentlyViewedComponent,
    RelatedProductsComponent,
    ProductReviewComponent,
    SubscribeComponent,
    FaqsComponent,
    BreadcrumbComponent,
    ProductSpecificationsComponent,
    AffirmWidgetComponent,
    PaypalWidgetComponent,
    ApplicationComponent,
    StarArrayPipe,
    SpinnerComponent,
    ProductOptionComponent,
    ProductColorSizeComponent,
    CheckFitmentComponent,
    CustomCurrencyPipe,
    WarrantyComponent,
    TruncateHtmlPipe,
    ReactiveFormsModule,
    SanitizeHtmlPipe,
    CartVerifyPopupComponent,
    ProductResourcesComponent
  ],
  host: { 'ngSkipHydration': 'true' },
})
export class ProductDetailsComponent implements OnInit {
  firstObj: number = this.appConstants.firstObj;
  cdnImagePath: string = environment.cdnImagePath;
  commonImagePath: string = environment.commonImagePath;
  imgBasePath: string = environment.imageBasePath;
  productData: any;
  skuData: any;
  order_key: number = null;
  product_key: number = null;
  category_key: number = null;
  product_variation_key: number = null;
  product_key_option_details: number = null;
  productName: string = '';
  productDescription: string = '';
  minPrice: number = 0;
  maxPrice: number = 0;
  samePrice: number = 0;
  isOption: boolean = false;
  isColor: boolean = false;
  isSize: boolean = false;
  isFreeShipping: boolean = false;
  variationCount: number = 0;
  warningMessage: number = 0;
  imageObject: Array<{ image: string; thumbImage: string }> = [];
  activeIndex = 0;
  productReviews: any[] = [];
  reviewsCount: number = 0;
  avgRating: number = 0;
  totalAverageOutOf5: number = 0;
  averageTotal: any;
  isSkuActive: boolean = null;
  selectedProductVariationKey: number = null;
  selectedSku: string = '';
  selectedSkuPrice: number = 0;
  msrpPrice: number = 0;
  skuDescription: string = '';
  isMaster: boolean = null;
  selectedSkuPhotos: any[] = [];
  selectedSkuSpecifications: any[] = [];
  isSelectedSkuInventoryAvailable: boolean = false;
  inventoryFlag: boolean = true;
  inventoryQty: number;
  productOptions: any[] = [];
  productVideo: any[] = [];
  productPhotos: any[] = [];
  brandLogo: any;
  selectedOption: any;
  promotionDiscount: number = null;
  productPromotion: any = {};
  promotionalPrice: number = null;
  promotion: number = null;
  promotionType: string = null;
  promotionDescription: string = null;
  isMapPricingPromo: boolean = false;
  selectedProductColour: number = null;
  selectedOptionsSkus: string[] = [];
  selectedOptionsSkuPrices: number[] = [];
  selectedOptionsQtys: number[] = [];
  selectedOptionsVariationKeys: number[] = [];
  selectedOptionKeys: Array<string> = [];
  requiredGroup: { [product_option_group_key: number]: number | '' } = {};
  selectedFinalPrice: number = 0;
  selectedFinalSkuString: string = '';
  selectedFinalNonPromotionalPrice: number = null;
  isOptionSelected: boolean = null;
  sanitizedEmbedCode: any[] = [];
  activeTab: 'image' | 'video' = 'image';
  showAddToCartButton: boolean = true;
  showCheckoutButton: boolean = false;
  showAddToCartForBestPriceButton: boolean = false;
  disableCheckoutButton: boolean = false;
  productDetailsInfoData: string = '';
  productResourcesData: any[] = [];
  faqsData: any[] = [];
  warrantyData: any[] = [];
  instructionsData: any[] = [];
  productImg: any;
  isMMYOn: boolean = false;
  make_key: number;
  model_key: number;
  year: string | number;
  vehicleSearch_Form: any = null;
  productFitToMMY: boolean = false;
  vehicleName: string;
  showMadeInUsaFlagSetting: boolean = true;
  showMMYNameSetting: boolean = true;
  showSkuDescriptionSetting: boolean = true;
  showQuestionsButtonSetting: boolean = true;
  showWhereToBuyButtonSettingGlobal: string;
  showWhereToBuyButtonSetting: boolean = true;
  showApplicationComponentSetting: boolean = true;
  showProductDetailsInfoComponentSetting: boolean = true;
  showAddToCartButtonMMYSetting: boolean = true;
  showSearchByVehicleButtonSetting: boolean = true;
  sectionMargins: { [key: string]: number } = {}
  baseUrl: string;
  quantity: number = 1;
  is_option: boolean = false;
  selectedTab: string = '';
  showGallery: boolean = false;
  showRelatedProducts: boolean = false;
  showRecentlyViewed: boolean = false;
  isAffirm: boolean = false;
  isPaypal: boolean = false;
  isLoading: boolean = true; // start true to prevent empty-content flash before first API call
  productOptionsLoaded = false;
  isReplacementSelected = false;
  relatedProducts: any[] = [];
  observer!: IntersectionObserver;
  stickyObserver!: IntersectionObserver;
  scrollHandler!: () => void;
  lastScrollY = 0;
  isScrollingDown = false;
  isStickyVisible = false;
  fitmentResponse: any[] = [];
  chTheme4 = environment.chTheme4;
  // Color and Size Selection
  selectedColorKey: number | null = null;
  selectedSizeKey: number | null = null;
  allColors: any[] = [];
  allSizes: any[] = [];
  availableColors: number[] = [];
  availableSizes: number[] = [];
  productColor: any[] = [];
  productSize: any[] = [];
  productVariations: any[] = [];
  showCheckFitment: boolean = false;
  touchStartX = 0;
  touchEndX = 0;
  minSwipeDistance = 50;
  isSearchByVehicleDisabled: boolean = false;
  defaultSubtitle: boolean = false;
  hideSubtitle: boolean = false;
  paypalClientId: string = '';
  videoUrl: string = '';
  productSubtitle: string = '';
  hasValidPrice = true;
  contact: string = environment.contact_no;
  formatted_contact: string = this.contact.replace(/(\d{3})(\d{3})(\d{4})/, "$1-$2-$3");
  brandName: string = '';
  categoryName: string = '';
  globalShowCheckFitment: boolean = false;
  links: any[] = []
  notifyForm: FormGroup;
  notifyErrorMessage: string = '';
  chTheme1 = environment.chTheme1;
  // Inventory related messages and flags
  inventoryMessages: {
    availabilityMsg: string;
    urgencyMsg: string;
    pickupMsg: string;
    showBackorder: boolean;
  } = null;
  warehouseType: 'karls' | 'partner' = 'karls';
  karls_qty: number;
  product_keys: number[] = [];
  breadcrumbData: { category_key: number; name: string }[] = [];
  addToCartFlag : boolean;
  showImagePopup = false;
  activeImg:string;
  popupActiveIndex = 0;
  productSpecialistContactInfo:any;
  corporateCustomer: string = '';
  merchantProductUrl: string = environment.merchantProductUrl;
  activeVideo: any;
  @ViewChild('specificationTab') specificationTab!: ElementRef<HTMLElement>;
  @ViewChild('applicationsTab') applicationsTab!: ElementRef<HTMLElement>;
  @ViewChild('checkFitmentTab') checkFitmentTab!: ElementRef<HTMLElement>;
  @ViewChild('productResourcesTab') productResourcesTab!: ElementRef<HTMLElement>;
  @ViewChild('faqsTab') faqsTab!: ElementRef<HTMLElement>;
  @ViewChild('instructionsTab') instructionsTab!: ElementRef<HTMLElement>;
  @ViewChild('gallaryPhotosTab') gallaryPhotosTab!: ElementRef<HTMLElement>;
  @ViewChild('relatedProductsTab') relatedProductsTab!: ElementRef<HTMLElement>;
  @ViewChild('recentlyViewedTab') recentlyViewedTab!: ElementRef<HTMLElement>;
  @ViewChild('reviewTab') reviewTab!: ElementRef<HTMLElement>;
  @ViewChild('warrantyTab') warrantyTab!: ElementRef<HTMLElement>;
  @ViewChild('partTab', { static: false }) partTab!: ElementRef;
  @ViewChild(ProductOptionComponent) productOptionChild: ProductOptionComponent;

  constructor(
    private appConstants: AppConstants,
    private productHttp: ProductService,
    private router: Router,
    public dialog: MatDialog,
    public comm: CommunicationService,
    private sanitizer: DomSanitizer,
    private route: ActivatedRoute,
    private cartService: CartService,
    private commonPageService: CommanpageService,
    private searchByVehicleService: SearchByVehicleService,
    private location: Location,
    private cdr: ChangeDetectorRef,
    private seoService: SeoService,
    private gtmService: GtmService,
    private fb: FormBuilder,
    private webinfoHttp: WebinfoService,
    private categoryService: CategoryService,
    private renderer: Renderer2 ,
     private footerHttp: FooterService,
     private browser: BrowserService,
    @Inject(DOCUMENT) private document: Document,
  ) {
    this.notifyForm = this.fb.group({
      email: [
        '',
        [
          Validators.required,
          Validators.email,
          Validators.pattern(/^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/),
        ],
      ],
    });
  }

  ngOnInit(): void {
    this.corporateCustomer = this.browser.localStorage?.getItem('isCorporateUser') || '';
    this.product_keys = this.browser.isBrowser
      ? JSON.parse(this.browser.localStorage?.getItem('recentlyViewedProducts') || '[]')
      : [];
    this.getProductSpecialistContactInfo();
    this.paypalClientId = this.commonPageService.paypalClientIdDetails();
    const vehicleBtnData = this.commonPageService.isSearchByVehicleDisabled();
    this.isSearchByVehicleDisabled = vehicleBtnData?.do_not_show;
    this.defaultSubtitle = this.commonPageService.isDefaultSubtitle();
    this.hideSubtitle = this.commonPageService.isSubtitleHidden();
    this.globalShowCheckFitment = this.commonPageService.isShowCheckFitment();
    this.baseUrl = this.browser.window?.location.origin;
    this.scrollToTop();
    this.cartService.selectProductSkuFlag$.subscribe((value) => {
      this.is_option = value;
    });
    this.comm.slugNotify.subscribe((data) => {
      if (data?.sku) {
        this.setSkuPage(data.sku, data.product_variation_key);
      }
    });
    this.comm.vehiclenameSubject.subscribe((name) => {
      this.vehicleName = name || '';
    });
    this.comm.clearVehicle.subscribe((response) => {
      if (response === true) {
        this.isMMYOn = false;
        this.make_key = null;
        this.model_key = null;
        this.year = '';
        this.vehicleSearch_Form = null;
      }
    });
    this.comm.cartItemRemoved$.subscribe((flag) => {
      if (flag) {
        this.buttonConfiguration();
      }
    });
    this.comm.fitmentNotify.subscribe(res => {
      const hasData =
        res?.[0]?.success &&
        res?.[0]?.data?.fitment_data &&
        res[0].data.fitment_data?.length > 0;
      this.fitmentResponse = hasData ? res : [];
    });
    (async () => {
      const mmyData = this.comm.vehicleFormSubject.value;
      if (mmyData) {
        this.isMMYOn = true;
        this.make_key = mmyData?.['select_make'] || null;
        this.model_key = mmyData?.['select_model'] || null;
        this.year = mmyData?.['select_year'] || '';
        this.vehicleSearch_Form = mmyData;
      }
      await this.fetchProductSettings();
      await this.setProductPage();
    })();
  }

  get isBrowser(): boolean { return this.browser.isBrowser; }

  get hasFitmentData(): boolean {
    return !!(
      this.fitmentResponse?.[0]?.data?.fitment_data?.length > 0
    );
  }
 
  setProductSticky() {
    if (!this.browser.isBrowser) return;
    this.lastScrollY = 0;
    this.isScrollingDown = false;
    this.isStickyVisible = false;
    setTimeout(() => {
      this.setupIntersectionObserver();
      this.setupStickyObserver();
    }, 2000);
  }

  setupStickyObserver(): void {
    if (!this.browser.isBrowser || !this.partTab?.nativeElement) return;
    const observerOptions = {
      root: null,
      threshold: 0,
    };
    if (this.scrollHandler) {
      this.browser.window?.removeEventListener('scroll', this.scrollHandler);
    }
    this.lastScrollY = this.browser.window?.scrollY;
    this.scrollHandler = () => {
      const currentScrollY = this.browser.window?.scrollY;
      this.isScrollingDown = currentScrollY > this.lastScrollY;
      this.lastScrollY = currentScrollY;
    };
    this.browser.window?.addEventListener('scroll', this.scrollHandler);
    if (this.stickyObserver) {
      this.stickyObserver.disconnect();
    }
    this.stickyObserver = new IntersectionObserver((entries) => {
      entries.forEach(entry => {
        if (!entry.isIntersecting && this.isScrollingDown) {
          this.isStickyVisible = true;
        } else if (entry.isIntersecting && !this.isScrollingDown) {
          this.isStickyVisible = false;
        }
        this.cdr.detectChanges();
      });
    }, observerOptions);
    this.stickyObserver.observe(this.partTab.nativeElement);
  }

  setupIntersectionObserver(): void {
    if (!this.browser.isBrowser) return;
    const sections = [
      { name: 'specification', ref: this.specificationTab },
      { name: 'applications', ref: this.applicationsTab },
      { name: 'fitment', ref: this.checkFitmentTab },
      { name: 'instruction', ref: this.instructionsTab },
      { name: 'productResources', ref: this.productResourcesTab },
      { name: 'faq', ref: this.faqsTab },
      { name: 'gallery', ref: this.gallaryPhotosTab },
      { name: 'relatedProd', ref: this.relatedProductsTab },
      { name: 'recentlyViewed', ref: this.recentlyViewedTab },
      { name: 'warranty', ref: this.warrantyTab },
      { name: 'review', ref: this.reviewTab },
    ].filter(s => !!s.ref?.nativeElement);
    if (!sections?.length) {
      console.warn('No sections found yet — observer not initialized');
      return;
    }
    const options = {
      root: null,
      rootMargin: '-45% 0px -55% 0px',
      threshold: 0,
    };
    if (this.observer) {
      this.observer?.disconnect();
    }
    this.observer = new IntersectionObserver((entries) => {
      entries.forEach(entry => {
        if (entry.isIntersecting) {
          const found = sections.find(s => s.ref.nativeElement === entry.target);
          if (found && this.selectedTab !== found.name) {
            this.selectedTab = found.name;
            this.cdr.detectChanges();
          }
        }
      });
    }, options);
    sections.forEach(section => {
      this.observer.observe(section.ref.nativeElement);
    });
  }

  showAddtoCart() {
    this.showAddToCartButton = true;
    this.showAddToCartForBestPriceButton = false;
    this.showCheckoutButton = false;
  }

  showCheckout() {
    this.showCheckoutButton = true;
    this.showAddToCartButton = false;
    this.showAddToCartForBestPriceButton = false;
  }

  showAddtoCartBestPrice() {
    this.showAddToCartForBestPriceButton = true;
    this.showAddToCartButton = false;
    this.showCheckoutButton = false;
  }

  increaseQuantity() {
    if (this.quantity < 100) {
      this.quantity++;
    }
  }

  decreaseQuantity() {
    if (this.quantity > 1) {
      this.quantity--;
    }
  }

  scrollTo(section: string): void {
    let el: HTMLElement | null = null;
    if (section === 'specification') {
      el = this.specificationTab?.nativeElement;
    } else if (section === 'applications') {
      el = this.applicationsTab?.nativeElement;
    } else if (section === 'instruction') {
      el = this.instructionsTab?.nativeElement;
    } else if (section === 'faq') {
      el = this.faqsTab?.nativeElement;
    } else if (section === 'fitment') {
      el = this.checkFitmentTab?.nativeElement;
    } else if (section === 'productResources') {
      el = this.productResourcesTab?.nativeElement;
    } else if (section === 'recentlyViewed') {
      el = this.recentlyViewedTab?.nativeElement;
    } else if (section === 'relatedProd') {
      el = this.relatedProductsTab?.nativeElement;
    } else if (section === 'gallery') {
      el = this.gallaryPhotosTab?.nativeElement;
    } else if (section === 'warranty') {
      el = this.warrantyTab?.nativeElement;
    } else if (section === 'review') {
      el = this.reviewTab?.nativeElement;
    }
    if (el) {
      const headerOffset = 240;
      const elementPosition = el.getBoundingClientRect().top + this.browser.window?.scrollY;
      const offsetPosition = elementPosition - headerOffset;
      this.browser.window?.scrollTo({
        top: offsetPosition,
        behavior: 'smooth'
      });
    }
  }

  fetchProductSettings() {
    this.productHttp.productSettings().subscribe({
      next: (response) => {
        const resObj = response?.[this.firstObj];
        if (resObj?.success === true) {
          const settings = resObj.data;
          const idx = this.firstObj;
          this.showMadeInUsaFlagSetting =
            settings?.made_in_usa_setting?.[idx]?.made_in_usa_setting === 'true';
          this.showMMYNameSetting =
            settings?.show_with_product_title_on_vehicle_search_pages?.[idx]
              ?.make_model_view_setting === 'true';
          this.showSkuDescriptionSetting =
            settings
              ?.show_sku_description_at_product_level_when_only_one_sku_exists?.[
              idx
            ]?.product_level_variation_name === 'true';
          this.showQuestionsButtonSetting =
            settings?.turn_questions_button_on_final_product_pages?.[idx]
              ?.contact_us_setting === 'true';
          this.showWhereToBuyButtonSettingGlobal =
            settings?.turn_on_where_to_buy_button_on_final_product_pages?.[idx]
              ?.where_to_buy_setting;
          this.showWhereToBuyButtonSetting =
            settings?.turn_on_where_to_buy_button_on_final_product_pages?.[idx]
              ?.where_to_buy_setting === 'true';
          this.showApplicationComponentSetting =
            settings?.hide_applications_on_product_pages?.[idx]
              ?.product_application_setting;
          this.showProductDetailsInfoComponentSetting =
            settings?.hide_product_details_on_product_pages?.[idx]
              ?.product_details_setting === 'true';
          this.showAddToCartButtonMMYSetting =
            settings
              ?.show_add_to_cart_button_on_vehicle_search_product_listing_page?.[
              idx
            ]?.show_add_to_cart_button === 'true';
          this.showSearchByVehicleButtonSetting =
            settings?.hide_make_model_and_year_dropdown_on_product_detail_pages?.[
              idx
            ]?.product_make_model_year_setting === 'false';
        }
      },
      error: (error) => {
        console.error(
          'Custom Error: Unexpected Error while fetching data from product-option-setting API',
          error
        );
      },
    });
  }

  async setSkuPage(sku: any, product_variation_key?: number): Promise<void> {
    const product_key = this.product_key || +this.browser.localStorage?.getItem('selectedproductkey') || null;
    const replaceDash = this.browser.localStorage?.getItem('replaceDashSku') === 'true';
    let checkSku = this.browser.localStorage?.getItem('checkSkuParam') || sku;
    if (replaceDash) checkSku = checkSku.replace('-', ' ');
    this.order_key = +this.browser.localStorage?.getItem('orderId') || null;
    if (!!checkSku) {
      let checkpromotion = false;
      if (this.product_key !== product_key) {
        await this.setContentData(product_key);
        checkpromotion = true;
      }
      this.selectedProductVariationKey = product_variation_key ?? (+this.browser.localStorage?.getItem('selectedproductvariationkey') || null);
      await this.setFreshPageForSkuLevel(
        this.selectedProductVariationKey,
        product_key,
        checkSku,
        checkpromotion
      );
      this.product_key = product_key;
      await this.checkPromotion(product_key);
      this.setSelectedFinalPriceAndSku();
      this.buttonConfiguration();
      this.productOptionsLoaded = true;
    }
  }

  async setProductPage(): Promise<void> {
    combineLatest([
      this.route.params,
      this.route.queryParams
    ]).subscribe(async ([params, qParams]) => {
      try {
        const idParam: string = params['id'] || '';
        let productKey = 0;
        if (idParam.startsWith('p')) {
          productKey = +idParam.substring(1);
        }
        if (!productKey && this.browser.isBrowser) {
          productKey = Number(this.browser.localStorage?.getItem('selectedproductkey'));
        }
        if (!productKey) return;
        this.product_key = productKey;
        if (this.browser.isBrowser) {
          this.browser.localStorage?.setItem('selectedproductkey', String(productKey));
        }
        this.selectedSizeKey = null;
        this.selectedColorKey = +qParams['selectedcolorkey'] || null;
        this.order_key = Number(this.browser.localStorage?.getItem('orderId')) || null;
        await this.setFreshPageForProductLevel(this.product_key, true);
        await this.setContentData(this.product_key);
      } catch (error) {
        console.error('Custom Error: Route Not Found...', error);
        this.commonPageService.pagenotfound();
      }
    });
  }

  async setProductDetails(product_key: number, product_variation_key: number) {
    try {
      await this.setContentData(product_key);
      if (this.product_key !== product_key) {
        this.product_key = product_key;
        this.selectedProductVariationKey = product_variation_key;
        if (this.selectedProductVariationKey != null) {
          await this.setFreshPageForSkuLevel(this.product_key, this.selectedProductVariationKey, '', true);
        } else {
          await this.setFreshPageForProductLevel(this.product_key, true);
        }
      } else {
        if (this.selectedProductVariationKey !== product_variation_key) {
          this.selectedProductVariationKey = product_variation_key;
          if (this.selectedProductVariationKey != null) {
            await this.setFreshPageForSkuLevel(this.product_key, this.selectedProductVariationKey, '', true);
          } else {
            this.isSkuActive = false;
          }
        }
      }
    } catch (error) {
      console.error('Error in setProductDetails:', error);
    }
  }

  async setFreshPageForSkuLevel(
    variationKey: number = this.selectedProductVariationKey,
    productKey: number = this.product_key,
    checkSku: string = '',
    toCheckPromotion: boolean = false
  ) {
    await this.fetchSkuLevelData(productKey, variationKey, checkSku);
    this.buttonConfiguration();
    if (this.product_key_option_details != this.product_key && (this.isOption || this.isColor || this.isSize)) {
      await this.fetchOptionsData(productKey);
      this.productOptionsLoaded = true;
    }
    if (this.isOption && this.productOptionChild) {
      const optionsData = await this.waitForChildOptions();
      this.selectedOptionsSkus = optionsData.skus;
      this.selectedOptionsSkuPrices = optionsData.prices;
      this.selectedOptionsQtys = optionsData.qtys;
      this.selectedOptionsVariationKeys = optionsData.variationKeys;
      this.selectedOptionKeys = optionsData.OptionKeys.map(String);
      this.requiredGroup = optionsData.requiredGroup;
    }
    toCheckPromotion ? await this.checkPromotion(productKey) : this.calculatePromotion();
    this.setSelectedFinalPriceAndSku();
  }

  waitForChildOptions(): Promise<{
    skus: string[];
    prices: number[];
    qtys: number[];
    variationKeys: number[];
    OptionKeys: string[];
    requiredGroup: any;
  }> {
    return new Promise(resolve => {
      const sub = this.productOptionChild.sendOptionsDataEvent.subscribe(data => {
        resolve(data);
        sub.unsubscribe();
      });
    });
  }

  async setFreshPageForProductLevel(
    productKey: number = this.product_key,
    toCheckPromotion: boolean = false
  ) {
    this.isOptionSelected = false;
    this.fetchProductLevelData(productKey).then(() => {
      this.fetchOptionsData(productKey).then(() => {
        this.productOptionsLoaded = true;
      });
    });
    if (this.isColor || this.isSize || this.isOption) {
      await this.fetchOptionsData(productKey);
      this.productOptionsLoaded = true;
    }
    toCheckPromotion
      ? this.checkPromotion(productKey)
      : this.calculatePromotion();
  }

  setProductImages(productPhotos: any[] = []): void {
    const defaultImage = `${this.commonImagePath}image_not_found.webp`;
    if (!Array.isArray(productPhotos) || productPhotos?.length === 0) {
      this.imageObject = [{ image: defaultImage, thumbImage: defaultImage }];
      return;
    }
    let filteredPhotos = productPhotos;
    // filter by color
    if (this.selectedColorKey) {
      filteredPhotos = filteredPhotos.filter(
        p => p.color_key === this.selectedColorKey
      );
    }
    // filter by size
    if (this.selectedSizeKey) {
      filteredPhotos = filteredPhotos.filter(p => {
        if (!p.size_keys) return false;
        const sizes = p.size_keys.split(',').map((s: string) => s.trim());
        return sizes.includes(String(this.selectedSizeKey));
      });
    }
    // fallback if nothing matched
    if (filteredPhotos?.length === 0) {
      filteredPhotos = productPhotos;
    }
    this.imageObject = filteredPhotos.map((photo: any) => {
      const largeImage = photo?.large_image
        ? this.cdnImagePath + photo.large_image
        : defaultImage;
      const thumbImage = photo?.thumb_image
        ? this.cdnImagePath + photo.thumb_image
        : defaultImage;
      return {
        image: largeImage,
        thumbImage: thumbImage,
        onErrorImage: defaultImage,
      };
    });
    this.activeIndex = 0;
  }

  async checkProductFitToMMY() {
    try {
      this.vehicleSearch_Form = await firstValueFrom(this.comm.vehicleFormSubject) || {};
      this.vehicleSearch_Form['product_key'] = this.product_key;
      const response: any = await firstValueFrom(this.productHttp.checkProductFitToMMY(this.vehicleSearch_Form));
      const result = response[this.firstObj];
      if (result?.success === true) {
        this.productFitToMMY = result.data?.exists;
      }
    } catch (error) {
      console.error("Fitment check failed", error);
    }
  }

  onImageError(event: Event): void {
    const image = event.target as HTMLImageElement;
    const defaultImage = `${this.commonImagePath}image_not_found.webp`;
    image.src = defaultImage;
  }

  nextImage(): void {
    if (this.imageObject?.length > 0) {
      this.activeIndex = (this.activeIndex + 1) % this.imageObject?.length;
    }
  }

  prevImage(): void {
    if (this.imageObject?.length > 0) {
      this.activeIndex =
        (this.activeIndex - 1 + this.imageObject?.length) % this.imageObject?.length;
    }
  }

  nextVideo(): void {
    if (this.sanitizedEmbedCode?.length > 0) {
      this.activeVideo = (this.activeVideo + 1) % this.sanitizedEmbedCode?.length;
    }
  }

  prevVideo(): void {
    if (this.sanitizedEmbedCode?.length > 0) {
      this.activeVideo = (this.activeVideo - 1 + this.sanitizedEmbedCode?.length) % this.sanitizedEmbedCode?.length;
    }
  }
 
closeImagePopup() {
  if (!this.browser.isBrowser) return;
  this.showImagePopup = false;
  this.renderer.removeStyle(this.document.documentElement, 'overflow');
}

  selectImage(index: number): void {
    this.activeIndex = index;
  }

  nextPopupImage(): void {
  if (this.imageObject?.length > 0) {
    this.popupActiveIndex =
      (this.popupActiveIndex + 1) % this.imageObject?.length;
  }
}

prevPopupImage(): void {
  if (this.imageObject?.length > 0) {
    this.popupActiveIndex =
      (this.popupActiveIndex - 1 + this.imageObject?.length) %
      this.imageObject?.length;
  }
}
viewSlider(i: number): void {
  if (!this.browser.isBrowser) return;
  this.popupActiveIndex = i;
  this.showImagePopup = true;
  this.renderer.setStyle(
    this.document.documentElement,
    'overflow',
    'hidden'
  );
}

  get activeImage(): string {
    return this.imageObject[this.activeIndex]?.image || '';
  }

  async fetchProductLevelData(product_key: number = this.product_key) {
    if (this.browser.isBrowser) this.isLoading = true;
    return new Promise<null>((resolve, reject) => {
      this.productHttp.singleProduct(product_key).subscribe({
        next: async (response) => {
          if (response[this.firstObj]?.success == true) {
            const data = response[this.firstObj]?.data;
            const url = this.browser.window?.location.href ?? '';
            if(!this.selectedColorKey){
              if (data.override_url && url.toString() !== data.override_url) {
                const splitUrl = data.override_url.split('/');
                this.router.navigate([`${splitUrl[splitUrl?.length - 2]}/${splitUrl[splitUrl?.length - 1]}`]);
              }
            }
            this.productData = data;
            this.brandName = data?.product_brand?.brand_name || '';
            this.categoryName = data?.product_categories?.[0]?.category?.name || '';
            this.variationCount = data?.variationCount || 0;
            this.videoUrl = data?.youtube_video_url || '';
            this.productVideo = [];
            this.sanitizedEmbedCode = [];
            const allEmbeds = [
              ...(data?.video_embed?.trim() ? [data.video_embed.trim()] : []),
              ...(data?.product_video || []).map((v: any) => v?.video_embed_code?.trim()).filter(Boolean)
            ];
            const uniqueEmbeds = [...new Set(allEmbeds)];
            if (uniqueEmbeds?.length > 0) {
              this.productVideo = uniqueEmbeds;
              this.sanitizedEmbedCode = uniqueEmbeds.map(html => this.sanitizer.bypassSecurityTrustHtml(html));
              this.activeVideo = 0;
            }
            this.category_key = data?.product_cat?.category?.category_key;
            this.addToCartFlag = data?.add_to_cart === 'on';
            const lastCategoryKey = this.category_key || this.categoryService.getLastCategoryKey();
            this.loadBreadcrumb(lastCategoryKey);
            this.showCheckFitment = data?.show_vehicle_button;
            if (this.showCheckFitment && !this.isSearchByVehicleDisabled && this.globalShowCheckFitment) {
              await this.checkProductFitToMMY(); 
            }
            if (this.variationCount === 1) {
              await this.setSkuPage(
                data?.product_variations[0]?.sku,
                data?.product_variations[0]?.product_variation_key
              );
              return;
            }
            this.setProductSticky();
            this.isSkuActive = false;
            this.productSubtitle = this.getProductSubtitle(data, null);
            if (this.productFitToMMY) {
              this.seoService.applySeo({
                title:
                  (data.override_page_title || data.name.replace(/\\/g, '')) +
                  ` ${this.vehicleName}`,
                description: data.override_meta_description,
              });
            } else {
              this.seoService.applySeo({
                title: data.override_page_title || data.name.replace(/\\/g, ''),
                description: data.override_meta_description,
              });
            }
            this.selectedProductVariationKey = data?.product_variations[0]?.product_variation_key || '';
            this.cdr.detectChanges();
            this.productImg = data?.product_photos[this.firstObj]?.small_image;
            this.browser.localStorage?.setItem('productImg', this.productImg);
            this.productName = data?.name.replace(/\\/g, '') || '';
            this.productPhotos = data?.product_photos || [];
            this.isOption = data?.is_option === "true";
            this.isColor = data?.is_color == "true";
            this.isSize = data?.is_size == "true";
            this.brandLogo = data?.product_brand?.small_image;
            this.isAffirm = data?.affirm_eligible;
            this.isPaypal = data?.paypal_eligible;
            this.browser.localStorage?.setItem('selectedProductName', this.productName);
            this.productDescription = this.fixEncoding(data?.short_description || '');
            this.browser.localStorage?.setItem('selectedProductDescription', this.productDescription);
            this.productDetailsInfoData = this.fixEncoding(data?.long_description || '');
            this.minPrice = data?.minPrice || null;
            this.maxPrice = data?.maxPrice || null;
            this.inventoryFlag = data?.inventory === 0;
            this.isFreeShipping = data?.is_shippable == 0;
            this.warningMessage = data?.warning_message || 0;
            this.selectedSkuSpecifications = [];
            if (!!this.showWhereToBuyButtonSettingGlobal && this.showWhereToBuyButtonSettingGlobal.toLowerCase() == 'product_level') {
              this.showWhereToBuyButtonSetting = data?.product?.where_to_buy == 'true';
            }
            this.setProductImages(this.productPhotos);
            this.getProductReviews(product_key);
            if (this.isColor || this.isSize) {
              if (this.selectedColorKey === null && this.selectedSizeKey === null) {
                this.selectedColorKey =
                  data?.product_variations[0]?.variation_colour?.color_key || null;
                this.selectedSizeKey =
                  data?.product_variations[0]?.variation_sizes[0]?.size_key || null;
                if (this.isColor || this.isSize) {
                  await this.setSkuPage(data?.product_variations[0]?.sku, data?.product_variations[0]?.product_variation_key);
                }
              } else {
                this.applicationdata();
              }
            }
            this.isLoading = false;
            this.emitProductSchema();
            resolve(null);
          } else {
            reject(null);
            this.commonPageService.pagenotfound();
          }
        },
        error: (error: Error) => {
          console.error(
            'Custom Error: Unexpected Error while loading Product level data',
            error
          );
          reject(null);
          this.commonPageService.pagenotfound();
        },
      });
    });
  }

  async fetchSkuLevelData(
    product_key: number = this.product_key,
    variationKey: number = this.selectedProductVariationKey,
    checkskuString: string = ''
  ): Promise<null> {
    return new Promise<null>((resolve, reject) => {
      const data: skuSlugPostDataInterface = {
        product_key,
        product_variation_key: variationKey,
        sku: checkskuString,
      };
      this.productHttp.getSkuSlug(data).subscribe({
        next: async (response) => {
          const respData = response?.[this.firstObj];
          if (respData?.success) {
            const data = respData.data?.[this.firstObj];
            this.skuData = data;
            this.brandName = data?.product?.brand?.brand_name || '';
            this.categoryName = data?.product_categories?.[0]?.category?.name || '';
            if(this.productData.add_to_cart == 'on') this.addToCartFlag = data?.add_to_cart === 'on'
            this.setProductSticky();
            this.isSkuActive = true;
            this.isColor = data?.is_color === "true"
            this.isSize = data?.is_size === "true"
            this.isOption = data?.is_option === "true"
            if (!this.selectedColorKey && !this.selectedSizeKey) {
              this.selectedColorKey =
                this.productData?.product_variations[0]?.variation_colour?.color_key ||
                null;
              this.selectedSizeKey =
                this.productData?.product_variations[0]?.variation_sizes[0]?.size_key ||
                null;
            }
            this.productSubtitle = this.getProductSubtitle(null, data);
            if (this.productFitToMMY) {
              this.seoService.applySeo({
                title:
                  (data.product.override_page_title ||
                    data.product.name.replace(/\\/g, '')) +
                  ` ${this.vehicleName}`,
                description: data.product.override_meta_description,
              });
            } else {
              this.seoService.applySeo({
                title:
                  data.product.override_page_title ||
                  data.product.name.replace(/\\/g, ''),
                description: data.product.override_meta_description,
              });
            }
            this.category_key = data?.product_categories?.[0]?.category?.category_key;
            this.cdr.detectChanges();
            this.selectedProductVariationKey = data?.product_variation_key || '';
            this.browser.localStorage?.setItem('selectedproductvariationkey', String(this.selectedProductVariationKey));
            this.product_key_option_details = data?.product_key;
            this.isMaster = Number(data?.is_master) === 1;
            this.isOption = data?.is_option === "true"
            this.selectedSku = data?.sku || '';
            this.skuDescription = data?.variation_name || '';
            this.warningMessage = data?.product?.warning_message || 0;
            this.isFreeShipping = data?.product?.is_shippable === 0;
            this.selectedSkuPrice = Number(data?.customer_price) || 0;
            this.checkPriceValidity(this.selectedSkuPrice);
            // Hide finance automatically
            this.isAffirm = this.hasValidPrice && data?.affirm_eligible;
            this.isPaypal = this.hasValidPrice && data?.paypal_eligible;
            this.msrpPrice = Number(data?.msrp_price) || 0;
            this.productName = data?.product?.name.replace(/\\/g, '') || '';
            this.productPhotos = data?.product_photos || [];
            this.brandLogo = data?.product?.brand?.small_image;
            this.browser.localStorage?.setItem('selectedProductName', this.productName);
            this.productDescription = this.fixEncoding(data?.product?.short_description || '');
            this.productDetailsInfoData = this.fixEncoding(data?.product?.long_description || '');
            this.inventoryFlag = respData?.data?.[1]?.[this.firstObj]?.inventory === 0;
            this.selectedSkuPhotos = data?.product_variation_photos || [];
            this.selectedSkuSpecifications = data?.product_variation_configuration || [];
            const fulfillmentInventory = data?.product_fulfillment_inventory || [];
            const karlsObj = fulfillmentInventory.find(
              (item: any) =>
                item?.branch_id === 'r&r' ||
                item?.product_fulfillment_location?.distributors === 'karlkustoms'
            );
            this.karls_qty = karlsObj?.qty || 0;
            this.inventoryQty = fulfillmentInventory.reduce(
              (sum: number, item: any) => sum + (Number(item.qty) || 0),
              0
            );
            this.isSelectedSkuInventoryAvailable = this.inventoryQty > 0;
            this.warehouseType = this.karls_qty > 0 ? 'karls' : 'partner';
            this.inventoryMessages = this.getInventoryMessages(
              this.inventoryQty,
              this.isSelectedSkuInventoryAvailable,
              this.warehouseType,
              this.karls_qty
            );
            if (this.showWhereToBuyButtonSettingGlobal?.toLowerCase() === 'product_level') {
              this.showWhereToBuyButtonSetting = data?.product?.where_to_buy === 'true';
            }
            this.setProductImages(this.productPhotos);
            this.getProductReviews(product_key);
            await this.fetchOptionsData(data.product_key);
            this.productOptionsLoaded = true;
            this.updateLinks();
            this.isLoading = false;
            this.emitProductSchema();
            resolve(null);
          } else {
            reject(null);
          }
        },
        error: (error: Error) => {
          console.error('Custom Error: Unexpected Error while fetching sku level data', error);
          reject(null);
        },
      });
    });
  }

  loadBreadcrumb(key: number) {
    this.categoryService.getCategoryBreadcrumb(key).subscribe(res => {
      if (res[0]?.success) {
        this.breadcrumbData = res[0].data || [];
      } else {
        this.breadcrumbData = [];
        console.warn('Unexpected breadcrumb response', res);
      }
      this.emitProductSchema();
    });
  }

  emitProductSchema(): void {
    const productName = this.productName;
    if (!productName) return;
    const allImages = this.imageObject.map(img => img.image).filter(src => !!src);
    const realImages = allImages.filter(src => !src.includes('image_not_found'));
    const images = realImages?.length > 0 ? realImages : allImages;
    let price: number | undefined;
    let minPrice: number | undefined;
    let maxPrice: number | undefined;
    if (this.isSkuActive) {
      const skuPrice = (this.promotion && !this.isMapPricingPromo)
        ? this.promotionalPrice
        : this.selectedSkuPrice;
      price = skuPrice > 0 ? skuPrice : undefined;
    } else {
      if (this.samePrice > 0) {
        price = this.samePrice;
      } else if (this.minPrice > 0) {
        minPrice = this.minPrice;
        maxPrice = this.maxPrice > 0 ? this.maxPrice : this.minPrice;
      }
    }
    const breadcrumb = [
      { name: 'Home', url: '/' },
      ...this.breadcrumbData.map(b => ({ name: b.name, url: `/category/c${b.category_key}` })),
      { name: productName },
    ];
    const reviews = this.productReviews.map(r => {
      const scores = [
        +r.appearance || 0,
        +r.installation || 0,
        +r.price_value || 0,
        +r.quality || 0,
      ];
      const rating = scores.reduce((a, b) => a + b, 0) / scores?.length;
      return {
        author: r.customer_name || (r.first_name ? `${r.first_name} ${r.last_name || ''}`.trim() : null) || r.author || 'Customer',
        rating,
        body: r.comments || r.review_body || undefined,
        datePublished: r.created_at || r.add_dt || undefined,
      };
    });
    this.seoService.applyProductSchema({
      name: productName,
      sku: this.selectedSku || undefined,
      mpn: this.selectedSku || undefined,
      brand: this.brandName || undefined,
      price,
      minPrice,
      maxPrice,
      priceCurrency: 'USD',
      availability: this.isSkuActive ? this.isSelectedSkuInventoryAvailable : true,
      images,
      description: this.productDescription || undefined,
      avgRating: this.avgRating > 0 ? this.avgRating : undefined,
      reviewCount: this.reviewsCount > 0 ? this.reviewsCount : undefined,
      reviews: reviews?.length > 0 ? reviews : undefined,
      canonicalUrl: this.browser.window?.location.href.split('?')[0],
      shippingMessage: this.inventoryMessages?.availabilityMsg || undefined,
      breadcrumb,
    });
  }

  getInventoryMessages(
    qty: number,
    isInStock: boolean,
    warehouse: 'karls' | 'partner' = 'karls',
    karlsQty: number = 0
  ) {
    const now = new Date();
    const cstTime = new Date(
      now.toLocaleString('en-US', { timeZone: 'America/Chicago' })
    );
    const day = cstTime.getDay();
    const hours = cstTime.getHours();
    const isSaturday = day === 6;
    const isSunday = day === 0;
    const isWeekday = day >= 1 && day <= 5;
    const before3PM = hours < 15;
    const beforeNoon = hours < 12;
    const after8AM = hours >= 8;
    let availabilityMsg = '';
    let urgencyMsg = '';
    let pickupMsg = '';
    if (!isInStock || Number(qty) <= 0) {
      return {
        availabilityMsg: 'Ships from Supplier in 2 to 4 Weeks (Pending Availability)',
        urgencyMsg: '',
        pickupMsg: 'Local pickup not available',
        showBackorder: true,
      };
    }
    if (qty <= 5) {
      urgencyMsg = `Only ${qty} left, order soon`;
    }
    if (karlsQty <= 0) {
      pickupMsg = 'Local pickup not available';
    }
    if (warehouse === 'karls') {
      const isAfterSatNoon = isSaturday && !beforeNoon;
      const isBeforeMon8AM = day === 1 && !after8AM;
      if (isAfterSatNoon || isSunday) {
        availabilityMsg = isSunday ? 'In Stock, expected to ship tomorrow' : 'In Stock ships Monday';
        if (karlsQty > 0) {
          pickupMsg = 'Local pick-up available Monday morning from 8AM to 12PM CST';
        } else {
          pickupMsg = 'Local pickup not available';
        }
        return {
          availabilityMsg,
          urgencyMsg,
          pickupMsg,
          showBackorder: false,
        };
      }
      if (isBeforeMon8AM) {
        availabilityMsg = 'In Stock, expected to ship today';
        if (karlsQty > 0) {
          pickupMsg = 'Local pick-up available today from 8AM to 5PM CST';
        } else {
          pickupMsg = 'Local pickup not available';
        }
        return {
          availabilityMsg,
          urgencyMsg,
          pickupMsg,
          showBackorder: false,
        };
      }
      if (isWeekday) {
        availabilityMsg = before3PM ? 'In Stock, expected to ship today' : 'In Stock, expected to ship tomorrow';
        if (karlsQty > 0) {
          pickupMsg = `${karlsQty} available for local pickup at Karl Kustoms in Des Moines, IA from 8AM to 5PM CST`;
        }
      }
      if (isSaturday) {
        availabilityMsg = 'In Stock ships Monday';
        if (!after8AM) {
          pickupMsg = karlsQty > 0 ? 'Local pick-up available Monday morning from 8AM to 12PM CST' : 'Local pickup not available';
        } else if (beforeNoon) {
          pickupMsg = karlsQty > 0 ? `${karlsQty} available for local pickup at Karl Kustoms in Des Moines, IA from 8AM to 12PM CST` : 'Local pickup not available';
        }
      }
    }
    if (warehouse === 'partner') {
      if (isWeekday) {
        availabilityMsg = before3PM ? 'In Stock, expected to ship today' : 'In Stock, expected to ship tomorrow';
      }
      if (isSaturday) {
        availabilityMsg = 'In Stock ships today or Monday';
      }
      if (isSunday) {
        availabilityMsg = 'In Stock, expected to ship tomorrow';
      }
    }
    return {
      availabilityMsg,
      urgencyMsg,
      pickupMsg,
      showBackorder: false,
    };
  }

  getPickupMsgHtml(): SafeHtml {
    const msg = this.inventoryMessages?.pickupMsg || '';
    const html = msg
      .replace(/^(\d+ available for local pickup)/, '<span style=" font-family:var(--font-secondary-bold)">$1</span>')
      .replace('at Karl Kustoms', '<span style="font-family:var(--font-secondary-bold)"><span style="font-family:var(--font-secondary-bold)"><strong><u>at Karl Kustoms</u></strong></span></span>');
    return this.sanitizer.bypassSecurityTrustHtml(html);
  }

  onNotifySubmit(): void {
    if (this.notifyForm.valid) {
      const email = this.notifyForm.get('email')?.value;
      const data = {
        email: email,
        product_key: this.skuData.product_key,
        variation_key: this.skuData.product_variation_key,
        sku: this.skuData.sku
      }
      this.webinfoHttp.product_notify(data).subscribe({
        next: (response) => {
          const res = response[0];
          if (res?.success === true) {
            this.openSubscribePopUpSuccess();
            this.notifyForm.reset();
            this.notifyErrorMessage = '';
          } else {
            this.notifyErrorMessage = res?.data || 'Please enter a valid email address.';
          }
        },
        error: () => {
          this.notifyErrorMessage = 'Something went wrong. Please try again.';
        },
      });
    } else {
      this.markFormGroupTouched(this.notifyForm);
      this.notifyErrorMessage = 'Please enter a valid email address.';
    }
  }

  openSubscribePopUpSuccess(): void {
    if (!this.browser.isBrowser) return;
    const dialogRef = this.dialog.open(SubscribePopupComponent, {
      width: '250px',
      data: { message: 'You will be automatically notified once the product is back in stock.' },
    });
    dialogRef.afterClosed().subscribe(() => { });
  }

  private markFormGroupTouched(formGroup: FormGroup) {
    Object.values(formGroup.controls).forEach((control) => {
      if (control instanceof FormGroup) {
        this.markFormGroupTouched(control);
      } else {
        control.markAsTouched();
      }
    });
  }

  async applicationdata() {
    const payload = {
      offset: String(0),
      limit: String(10),
      size: String(this.selectedSizeKey) || null,
      color: this.selectedColorKey || null,
      make: this.productFitToMMY ? this.vehicleSearch_Form?.select_make || '' : '',
      model: this.productFitToMMY ? this.vehicleSearch_Form?.select_model || '' : '',
      year: this.productFitToMMY ? this.vehicleSearch_Form?.select_year || '' : '',
      sub_model_1: this.productFitToMMY ? this.vehicleSearch_Form?.sub_model_1 || '' : '',
      sub_model_2: this.productFitToMMY ? this.vehicleSearch_Form?.sub_model_2 || '' : '',
      sub_model_3: this.productFitToMMY ? this.vehicleSearch_Form?.sub_model_3 || '' : ''
    };
    this.productHttp.productVariations(this.product_key, payload).subscribe({
      next: async (response) => {
        if (response[this.firstObj]?.success === true) {
          const data = response[this.firstObj]?.data;
          const productVariations = data?.all_product_variations || [];
          const totalVariationsCount = data?.all_product_variations_count || 0;
          if (totalVariationsCount == 1) {
            await this.setSkuPage(productVariations?.[this.firstObj]?.sku, productVariations?.[this.firstObj]?.product_variation_key);
          }
        }
      }
    });
  }

  checkPriceValidity(price: number | null | undefined) {
    this.hasValidPrice = Number(price) > 0;
  }

  getProductSubtitle(productData?: any, skuData?: any): string {
    let tagline = '';
    let config: any = null;
    // SKU Data
    if (skuData) {
      tagline = skuData?.product?.tagline?.trim() || '';
      config = skuData?.product_variation_configuration?.[0];
    }
    // Product Data
    else if (productData) {
      tagline = productData?.tagline?.trim() || '';
      config = productData?.product_variations?.[0]?.product_variation_configuration?.[0];
    }
    if (this.hideSubtitle) {
      return '';
    }
    if (this.defaultSubtitle) {
      return tagline;
    }
    if (tagline) {
      return tagline;
    }
    const specLabel = this.extractSpecificationValues(
      config?.specification_label1 || ''
    );
    const specValue = this.extractSpecificationValues(
      config?.specification_value1 || ''
    );
    if (specLabel || specValue) {
      return `${specLabel} ${specValue}`.trim();
    }
    return '';
  }

  extractSpecificationValues(htmlString: string): string {
    if (!htmlString) return '';
    const doc = this.browser.doc;
    if (!doc) return '';
    const tempDiv = doc.createElement('div');
    tempDiv.innerHTML = htmlString;
    const liElements = tempDiv.querySelectorAll('li');
    const values: string[] = [];
    liElements.forEach(li => {
      let text = li.textContent || '';
      text = this.fixEncoding(text);
      const parts = text.split(':');
      if (parts?.length > 1) {
        values.push(parts.slice(1).join(':').trim());
      }
    });
    return values.join(', ');
  }

  fixEncoding(text: string): string {
    if (!text) return '';
    const doc = this.browser.doc;
    if (!doc) return text.replace(/\\\\/g, '').replace(/\s+/g, ' ').trim();
    const textarea = doc.createElement('textarea');
    textarea.innerHTML = text;
    return textarea.value
      .replace(/&Atilde;&#151;/g, '×')
      .replace(/Ã—/g, '×')
      .replace(/”¢/g, '•')
      .replace(/¢/g, '•')
      .replace(/\\/g, '')
      .replace(/\s+/g, ' ')
      .trim();
  }

  onContactClick(productName: any) {
    this.router.navigate(['/contact-us'], {
      queryParams: { subject: `${productName}` },
    });
  }

  getProductReviews(product_key: number) {
    this.productHttp.selectedProductReview(product_key).subscribe(response => {
      if (response[this.firstObj]?.success) {
        this.productReviews = response[this.firstObj].data.reviews || [];
        this.reviewsCount = this.productReviews?.length;
        if (this.productReviews?.length > 0) {
          const sum = this.productReviews.reduce((acc: number, review: any) => {
            const scores = [
              +review.appearance || 0,
              +review.installation || 0,
              +review.price_value || 0,
              +review.quality || 0,
            ];
            const reviewAvg = scores.reduce((a, b) => a + b, 0) / scores?.length;
            return acc + reviewAvg;
          }, 0);
          this.avgRating = sum / this.reviewsCount;
        } else {
          this.avgRating = 0;
        }
        this.emitProductSchema();
      }
    });
  }

  getSingleVariationPrices({
    promotionalPrice,
    price,
    selectedProductVariationKey,
    selectedSku,
    isSelectedSkuInventoryAvailable
  }) {
    this.selectedFinalPrice = !!promotionalPrice ? promotionalPrice : price;
    this.promotionalPrice = promotionalPrice || null;
    this.selectedFinalNonPromotionalPrice = +price;
    this.selectedSkuPrice = +price;
    this.selectedProductVariationKey = +selectedProductVariationKey;
    this.selectedSku = selectedSku;
    this.isSelectedSkuInventoryAvailable = isSelectedSkuInventoryAvailable;
    this.buttonConfiguration();
  }

  getSamePrice(samePrice: number) {
    this.samePrice = samePrice;
  }

  // Fetching options data
  async fetchOptionsData(product_key: number = this.product_key) {
    return new Promise<null>((resolve, reject) => {
      this.productHttp.getOptions(product_key).subscribe({
        next: (response) => {
          if (response[this.firstObj]?.success === true) {
            const data = response[this.firstObj].data;
            this.productOptions = data[0]?.product_option_group || [];
            this.allColors = data[1]?.color || [];
            this.allSizes = data[2]?.size || [];
            // unique color & size for UI
            this.productColor = this.uniqueBy(this.allColors, 'color_key');
            this.productSize = this.uniqueBy(this.allSizes, 'size_key');
            this.productVariations = data;
            this.updateAvailability();
            resolve(null);
          } else {
            reject(null);
          }
        },
        error: (error: Error) => {
          console.error('Error fetching options', error);
          reject(null);
        },
      });
    });
  }

  async onSelectColor(colorKey: number | null) {
    if (colorKey && colorKey < 0) {
      this.selectedColorKey = Math.abs(colorKey);
      this.selectedSizeKey = null;
      this.updateAvailability();
      if (this.isSkuActive) {
        await this.fetchProductLevelData(this.product_key);
      }
      return;
    }
    this.selectedColorKey = colorKey;
    if (
      this.selectedSizeKey &&
      !this.getSizesByColor(colorKey).some(s => s.size_key === this.selectedSizeKey)
    ) {
      this.selectedSizeKey = null;
    }
    this.updateAvailability();
    if (this.isSkuActive) {
      await this.fetchProductLevelData(this.product_key);
    }
  }

  async onSelectSize(sizeKey: number | null) {
    if (sizeKey && sizeKey < 0) {
      this.selectedSizeKey = Math.abs(sizeKey);
      this.selectedColorKey = null;
      this.updateAvailability();
      if (this.isSkuActive) {
        await this.fetchProductLevelData(this.product_key);
      }
      return;
    }
    this.selectedSizeKey = sizeKey;
    if (
      this.selectedColorKey &&
      !this.getColorsBySize(sizeKey).some(c => c.color_key === this.selectedColorKey)
    ) {
      this.selectedColorKey = null;
    }
    this.updateAvailability();
    if (this.isSkuActive) {
      await this.fetchProductLevelData(this.product_key);
    }
  }

  // Update available options based on current selection
  updateAvailability() {
    this.availableSizes = this.selectedColorKey
      ? this.getSizesByColor(this.selectedColorKey).map(s => s.size_key)
      : this.productSize.map(s => s.size_key);
    this.availableColors = this.selectedSizeKey
      ? this.getColorsBySize(this.selectedSizeKey).map(c => c.color_key)
      : this.productColor.map(c => c.color_key);
    if (!this.isSkuActive) {
      this.setProductImages(this.productPhotos);
    }
  }

  // Get sizes available for a color
  getSizesByColor(colorKey: number | null) {
    if (!colorKey) return [];
    const variationKeys = this.allColors
      .filter(c => c.color_key === colorKey)
      .map(c => c.product_variation_key);
    return this.uniqueBy(
      this.allSizes.filter(s =>
        variationKeys.includes(s.product_variation_key)
      ),
      'size_key'
    );
  }

  // Get colors available for a size
  getColorsBySize(sizeKey: number | null) {
    if (!sizeKey) return [];
    const variationKeys = this.allSizes
      .filter(s => s.size_key === sizeKey)
      .map(s => s.product_variation_key);
    return this.uniqueBy(
      this.allColors.filter(c =>
        variationKeys.includes(c.product_variation_key)
      ),
      'color_key'
    );
  }

  uniqueBy(arr: any[], key: string) {
    return Array.from(new Map(arr.map(i => [i[key], i])).values());
  }

  async setContentData(productKey: number = this.product_key) {
    return new Promise<null>(async (resolve) => {
      try {
        const data = await this.productHttp.fetchProductDetailsContent(productKey);
        this.productResourcesData = data?.product_resources || [];
        this.faqsData = data?.product_faqs || [];
        this.warrantyData = data?.product_warranties || [];
        this.instructionsData = data?.productInstructions || [];
        resolve(null);
      } catch (error) {
        console.error('Custom Error: Unexpected Error while fetching data from product-details-content api', error);
        resolve(null);
      }
    });
  }

  setSelectedFinalPriceAndSku() {
    this.selectedFinalNonPromotionalPrice = this.selectedSkuPrice;
    this.selectedFinalPrice = !!this.promotion
      ? this.promotionalPrice
      : this.selectedFinalNonPromotionalPrice;
    this.selectedFinalSkuString = this.selectedSku;
    if (this.selectedOptionsSkuPrices?.length > 0) {
      for (let i = 0; i < this.selectedOptionsSkuPrices?.length; i++) {
        this.selectedFinalPrice += this.selectedOptionsSkuPrices[i] * this.selectedOptionsQtys[i];
        this.selectedFinalNonPromotionalPrice += this.selectedOptionsSkuPrices[i] * this.selectedOptionsQtys[i];
        let sku = this.selectedOptionsSkus[i];
        if (sku != '') {
          this.selectedFinalSkuString += ' | ' + sku;
        }
      }
    }
    this.selectedFinalPrice = this.selectedFinalPrice < 0 ? 0 : this.selectedFinalPrice;
  }

  onSelectOptions({
    skus,
    prices,
    qtys,
    variationKeys,
    OptionKeys,
    requiredGroup,
  }) {
    this.selectedOptionsSkus = skus;
    this.selectedOptionsSkuPrices = prices;
    this.selectedOptionsQtys = qtys;
    (this.selectedOptionsVariationKeys = variationKeys);
    (this.requiredGroup = requiredGroup);
    this.isOptionSelected = true;
    this.selectedOptionKeys = OptionKeys.map(String);
    this.setSelectedFinalPriceAndSku();
  }

  async onSelectProductReplacement({ variationKey, productKey, isReplacement }: any) {
    this.selectedOptionsSkuPrices = [];
    this.selectedOptionsQtys = [];
    this.selectedOptionsSkus = [];
    this.selectedOptionsVariationKeys = [];
    this.selectedOptionKeys = [];
    this.promotion = null;
    this.promotionalPrice = null;
    this.promotionType = null;
    this.promotionDiscount = null;
    this.productPromotion = null;
    this.isReplacementSelected = !!isReplacement;
    await this.setContentData(productKey);
    await this.setFreshPageForSkuLevel(variationKey, productKey, '', true);
    if (this.product_key !== productKey) {
      this.product_key = productKey;
    }
    await this.checkPromotion(productKey);
    this.calculatePromotion();
    if (!this.promotion || this.promotionalPrice == null) {
      this.promotionalPrice = null;
      this.selectedFinalPrice = this.selectedSkuPrice;
      this.selectedFinalNonPromotionalPrice = this.selectedSkuPrice;
    } else {
      this.selectedFinalPrice = this.promotionalPrice;
      this.selectedFinalNonPromotionalPrice = this.selectedSkuPrice;
    }
    this.setSelectedFinalPriceAndSku();
  }

  async checkPromotion(product_key: number = this.product_key) {
    if (!this.browser.isBrowser) return;
    try {
      this.productPromotion =
        (await this.productHttp.getPromotions(product_key)) || {};
      this.promotionDiscount =
        this.productPromotion?.[this.firstObj]?.data?.[this.firstObj]
          ?.discount || null;
      this.promotionType =
        this.productPromotion?.[this.firstObj]?.data?.[this.firstObj]
          ?.promotion_type || null;
      this.promotionDescription =
        this.productPromotion?.[this.firstObj]?.data?.[this.firstObj]
          ?.one_line_description || null;
      this.calculatePromotion();
    } catch (error) {
      console.error(
        'Custom Error: Unexpected Error while fetching prmotion from api',
        error
      );
      this.resetPromotionToBasePrice();
    }
  }

  resetPromotionToBasePrice(): void {
    this.promotion = null;
    this.productPromotion = null;
    this.promotionDiscount = null;
    this.productPromotion=null;
    this.promotionType = null;
    this.promotionalPrice = null;
    this.selectedFinalNonPromotionalPrice = this.selectedSkuPrice;
    this.selectedFinalPrice = this.selectedSkuPrice;
  }

  calculatePromotion(): void {
    if(this.productPromotion){
      this.isMapPricingPromo = this.productPromotion[this.firstObj]?.data?.[this.firstObj]?.is_map_pricing_promo == '1';
      if (!this.isMapPricingPromo) {
        this.promotion = this.productPromotion[this.firstObj]?.data[this.firstObj]?.discount || 0;
        if (this.promotionType == 'percentage_discount') {
          this.promotionalPrice = this.selectedSkuPrice - this.selectedSkuPrice * (this.promotion / 100);
        } else if (this.promotionType == 'discount_flat_rate') {
          this.promotionalPrice = this.selectedSkuPrice - this.promotion;
        }
        this.selectedFinalPrice = this.promotionalPrice;
        this.selectedFinalNonPromotionalPrice = this.selectedSkuPrice;
      }else {
        this.resetPromotionToBasePrice();
      }
    }else {
      this.resetPromotionToBasePrice();
    }
  }

  toggleTab(tab: 'image' | 'video') {
    this.activeTab = tab;
  }

  async onAddToCart() {
    const requiredGroup = Object.values(this.requiredGroup);
    if (requiredGroup.includes('') && this.productOptions?.length > 0) {
      this.dialog.open(ProductOptionErrorpopupComponent);
      return;
    }
    const isNewProductFreight = this.skuData?.is_freight_shipping == 1;
    const cartShippingType = this.cartService.getCartShippingType();
    if (cartShippingType !== null) {
      const cartIsFreight = cartShippingType === 'freight';
      if (cartIsFreight !== isNewProductFreight) {
        this.dialog.open(CartVerifyPopupComponent, {
          data: {
            messages: [cartIsFreight ? 'Your cart contains freight shipping items. Only freight shipping products can be added.' : 'Your cart contains standard shipping items. Only standard shipping products can be added.'],
            isFreight: cartIsFreight
          }
        });
        return;
      }
    }
    let price = 0;
    let promotion_key = null;
    price = this.isOptionSelected
      ? this.selectedFinalPrice
      : !!this.promotion
        ? this.promotionalPrice
        : this.selectedSkuPrice;
    const product = {
      product_key: this.product_key,
      product_variation_key: this.selectedProductVariationKey,
      sku: this.selectedSku,
    };
    this.disableCheckoutButton = true;
    const product_option_key = !this.isReplacementSelected
      ? this.selectedOptionKeys.filter(k => k).join(',')
      : null;
    try {
      if (this.is_option && this.productOptions?.length > 0 && !this.isReplacementSelected) {
        const optionProducts = this.selectedOptionsVariationKeys.map((variationKey, index) => ({
          variation_key: variationKey,
          sku: this.selectedOptionsSkus[index],
          price: this.selectedOptionsSkuPrices[index],
        }));
        await this.cartService.addOptionsToCart(
          product,
          this.order_key,
          1,
          price,
          promotion_key,
          product_option_key,
          this.selectedColorKey,
          this.selectedSizeKey,
          optionProducts
        );
        this.gtmService.pushEvent('add_to_cart', {
          ecommerce: {
            currency: 'USD',
            value: Number(price),
            items: [
              {
                item_id: this.selectedProductVariationKey,
                item_name: this.productName,
                item_brand: this.brandName,
                item_category: this.categoryName,
                price: Number(price),
                quantity: 1
              }
            ]
          }
        });
      } else {
        await this.cartService.addToCart(
          product,
          this.order_key,
          1,
          price,
          promotion_key,
          false,
          product_option_key,
          false,
          this.selectedColorKey,
          this.selectedSizeKey
        );
        this.gtmService.pushEvent('add_to_cart', {
          ecommerce: {
            currency: 'USD',
            value: Number(price),
            items: [
              {
                item_id: this.selectedProductVariationKey,
                item_name: this.productName,
                item_brand: this.brandName,
                item_category: this.categoryName,
                price: Number(price),
                quantity: 1
              }
            ]
          }
        });
      }
      this.cartService.setCartShippingType(isNewProductFreight);
      this.comm.itemCount.next(null);
      this.showCheckout();
    } catch (error) {
      console.error('Error adding to cart:', error);
    } finally {
      this.disableCheckoutButton = false;
    }
  }

  getDisabledButton(value: boolean) {
    this.disableCheckoutButton = value;
  }

  buttonConfiguration() {
    const orderItemObject = this.cartService.getOrderItemsList();
    let items = [];
    !!orderItemObject ? (items = Object.keys(orderItemObject)) : null;
    items?.length > 0 && items.includes(`${this.selectedProductVariationKey}`) ? this.showCheckout() : this.showAddtoCart();
  }

  scrollToApplicationsTab() {
    if (this.applicationsTab && this.applicationsTab.nativeElement) {
      this.applicationsTab.nativeElement.scrollIntoView({
        behavior: 'smooth',
        block: 'start',
      });
    }
  }

  onClickQuestions() {
    let price = '';
    if (this.isSkuActive) {
      price =
        '$' +
        (this.isOptionSelected
          ? String(this.selectedFinalPrice)
          : !!this.promotion
            ? String(this.promotionalPrice)
            : String(this.selectedSkuPrice));
    } else {
      price = '$' + String(this.maxPrice) + ' - ' + '$' + String(this.minPrice);
    }
    this.router.navigate(['/contact-us'], {
      queryParams: { subject: this.productName + ' - ' + price },
    });
  }

  getTotalAverageOutOf5(totalAverageOutOf5: number) {
    this.totalAverageOutOf5 = totalAverageOutOf5;
  }

  getTotalReviewsCount(count: number) {
    this.reviewsCount = count;
  }

  openLoveItPopup(): void {
    this.browser.localStorage?.setItem('selectedproductkey', String(this.product_key));
    this.browser.localStorage?.setItem('selectedProductName', this.productName);
    this.dialog.open(LoveItPopupComponent, {
      data: { product_name: this.productData.name, prod_description: this.productData.short_description, prod_image: this.productData.product_photos[0].medium_image, product_key:this.productData.product_key },
    });
  }

  openReviewItPopup(): void {
    const dialogRef = this.dialog.open(ReviewItPopupComponent, {
      data: {
        reviews: this.productReviews,
        avgRating: this.totalAverageOutOf5,
        reviewsCount: this.reviewsCount,
        productName: this.productName,
        product_key: this.product_key,
        productImg: this.imageObject?.[this.firstObj]?.image
      }
    });
    dialogRef.afterClosed().subscribe();
  }

  openWishlist(): void {
    const data: wishlistPostDataInterface = {
      qty: 1,
      calculated_price: this.isSkuActive ? this.skuData.customer_price : this.productData?.product_variations?.[0]?.price,
      product_variation_key: this.isSkuActive ? this.skuData.product_variation_key : this.productData?.product_variations?.[0]?.product_variation_key,
      save_for_later: false,
    };
    this.productHttp.wishlist(data).subscribe({
      next: (response) => {
        if (
          response.status === 'Token is Invalid' ||
          response.status === 'Token is Expired' ||
          response.status == 'Authorization Token not found'
        ) {
          this.router.navigate(['/customer-login']);
        } else if (response[0].data === "Your item has been added to your list.") {
          const price = Number(this.productData?.product_variations?.[0]?.price) || 0;
          this.gtmService.pushEvent('add_to_wishlist', {
            ecommerce: {
              currency: 'USD',
              value: price,
              items: [
                {
                  item_id: this.isSkuActive ? this.skuData?.product_variation_key : this.productData?.product_variations?.[0]?.product_variation_key,
                  item_name: this.productData?.name,
                  item_brand: this.productData?.product_brand?.brand_name,
                  item_category: this.productData?.product_categories?.[0]?.category?.name,
                  price: price,
                  quantity: 1
                }
              ]
            }
          });
          let wishItems = Number(this.browser.localStorage?.getItem('wishlistItem')) || 0;
          wishItems = wishItems + 1;
          this.browser.localStorage?.setItem('wishlistItem', String(wishItems));
          this.comm.setCount(wishItems);
          this.openWishlistSuccess();
        } else {
          this.openWishlistSuccess();
        }
      },
      error: (error: Error) => {
        this.router.navigate(['/customer-login']);
        console.error('Custom Error: Unexpected Error while fetching wishlist', error);
      },
    });
  }

  openWishlistSuccess(): void {
    const dialogRef = this.dialog.open(WishlistPopupComponent, {
      width: '250px',
      data: { message: 'Product added to wishlist successfully.' },
    });
    dialogRef.afterClosed().subscribe(() => { });
  }

  openSearchByVehicle() {
    this.dialog.open(SearchByVehicleComponent);
  }

  onClearSearchVehicle() {
    this.searchByVehicleService.clearVehicleSearch();
    this.make_key = null;
    this.model_key = null;
    this.year = null;
    this.isMMYOn = false;
  }

  share(platform: string) {
    const formattedProductName = this.productName
      .replace(/\s+/g, '-')
      .toLowerCase();
    const url = encodeURIComponent(
      `${this.baseUrl}/${formattedProductName}/p${this.product_key}`
    );
    let shareUrl = '';
    switch (platform) {
      case 'twitter':
        shareUrl = `https://twitter.com/intent/tweet?url=${url}&text=${this.productName}`;
        break;
      case 'facebook':
        shareUrl = `http://www.facebook.com/sharer.php?u=${url}`;
        break;
      case 'instagram':
        shareUrl = `https://www.instagram.com/direct/new/?text=${encodeURIComponent(
          `${this.productName} - ${decodeURIComponent(url)}`
        )}`;
        break;
      case 'youtube':
        shareUrl = `${this.videoUrl}`;
        break;
    }
    this.browser.window?.open(
      shareUrl,
      '_blank',
      'toolbar=no,location=no,status=no,menubar=no,scrollbars=no,resizable=no,width=600,height=300'
    );
  }

  scrollToSection(sectionId: string) {
    const doc = this.browser.doc;
    if (!doc) return;
    const element = doc.getElementById(sectionId);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth', block: 'start' });
    } else {
      console.error('Element not found:', sectionId);
    }
  }

  downloadInstruction() {
    if (!this.instructionsData?.length) {
      console.warn('No instructions available to open.');
      return;
    }
    const fileName = this.instructionsData[0].instruction_file;
    const fileUrl = `${this.cdnImagePath}${fileName}`;
    this.browser.window?.open(fileUrl, '_blank');
  }

  openVechicleSearchPopup(): void {
    const dialogRef = this.dialog.open(SearchByVehicleComponent, {
      width: '600px',
      panelClass: 'search-by-vehicle-dialog',
      data: {
        product_key: this.product_key
      }
    });
    dialogRef.afterClosed().subscribe(() => {
      this.checkProductFitToMMY();
    });
  }

  clearVehicle() {
    this.searchByVehicleService.clearVehicleSearch();
  }

  getDisplayedPrice() {
    if ((this.isSkuActive || this.variationCount === 1) && this.isOptionSelected) {
      return this.truncatePrice(this.selectedFinalPrice);
    }
    if ((this.isSkuActive || this.variationCount === 1) && this.promotion && !this.isMapPricingPromo) {
      return this.truncatePrice(this.promotionalPrice);
    }
    if (this.isSkuActive || this.variationCount === 1) {
      return this.truncatePrice(this.selectedSkuPrice);
    }
    if (this.minPrice !== this.maxPrice) {
      return `${this.truncatePrice(this.minPrice)} - ${this.truncatePrice(this.maxPrice)}`;
    }
    return this.truncatePrice(this.samePrice);
  }

  truncatePrice(price: number) {
    if (typeof price === 'number') {
      return (Math.floor(price * 100) / 100).toFixed(2);
    }
    return price;
  }

  get showStrikePrice(): boolean {
    if (!(this.isSkuActive || this.variationCount === 1)) return false;
    if (this.promotion && !this.isMapPricingPromo) return true;
    return !!this.msrpPrice && this.msrpPrice > this.selectedSkuPrice;
  }

  get strikePrice(): number {
    if (this.promotion && !this.isMapPricingPromo) {
      return this.selectedFinalNonPromotionalPrice;
    }
    return this.msrpPrice || 0;
  }

  get affirmPriceCents(): number | null {
    if ((this.isSkuActive || this.variationCount === 1) && this.isOptionSelected) {
      return this.selectedFinalPrice ? Math.round(this.selectedFinalPrice * 100) : null;
    }
    if ((this.isSkuActive || this.variationCount === 1) && this.promotion && !this.isMapPricingPromo) {
      return this.promotionalPrice ? Math.round(this.promotionalPrice * 100) : null;
    }
    if ((this.isSkuActive || this.variationCount === 1)) {
      return this.selectedSkuPrice ? Math.round(this.selectedSkuPrice * 100) : null;
    }
    if (this.minPrice !== this.maxPrice) {
      return this.minPrice ? Math.round(this.minPrice * 100) : null;
    }
    return this.samePrice ? Math.round(this.samePrice * 100) : null;
  }

  get paypalPrice(): number | null {
    if ((this.isSkuActive || this.variationCount === 1) && this.isOptionSelected) {
      return this.selectedFinalPrice ? Math.round(this.selectedFinalPrice) : null;
    }
    if ((this.isSkuActive || this.variationCount === 1) && this.promotion && !this.isMapPricingPromo) {
      return this.promotionalPrice ? Math.round(this.promotionalPrice) : null;
    }
    if ((this.isSkuActive || this.variationCount === 1)) {
      return this.selectedSkuPrice ? Math.round(this.selectedSkuPrice) : null;
    }
    if (this.minPrice !== this.maxPrice) {
      return this.minPrice ? Math.round(this.minPrice) : null;
    }
    return this.samePrice ? Math.round(this.samePrice) : null;
  }

  selectTab(tab: string): void {
    this.selectedTab = tab;
  }

  onGalleryStatus(hasData: boolean): void {
    this.showGallery = hasData;
  }

  onRelatedProductData(data: any[]) {
    this.relatedProducts = data;
  }

  onRelatedProductStatus(hasData: boolean): void {
    this.showRelatedProducts = hasData;
  }

  onRecentlyViewedStatus(hasData: boolean): void {
    this.showRecentlyViewed = hasData;
  }

  scrollToTop() {
    this.browser.window?.scrollTo({ top: 0, behavior: 'smooth' });
  }

  goBack(): void {
    this.location.back();
  }

  onTouchStart(event: TouchEvent) {
    this.touchStartX = event.changedTouches[0].screenX;
  }

  onTouchEnd(event: TouchEvent) {
    if (this.showImagePopup) return;
    this.touchEndX = event.changedTouches[0].screenX;
    this.handleSwipe();
  }

  handleSwipe() {
    const distance = this.touchStartX - this.touchEndX;
    if (Math.abs(distance) > this.minSwipeDistance) {
      if (distance > 0) {
        this.nextImage();
      } else {
        this.prevImage();
      }
    }
  }

  updateLinks() {
  this.links = [
      {
        label: 'Specifications',
        show: this.selectedSkuSpecifications?.length > 0
      },
      {
        label: 'Applications',
        show: this.variationCount > 0 && !this.isSkuActive && this.showApplicationComponentSetting
      },
      // {
      //   label: 'Check Fitment',
      //   show: !this.isSkuActive && !this.vehicleName && this.showCheckFitment && !this.isSearchByVehicleDisabled && this.globalShowCheckFitment,
      //   action: () => this.openVechicleSearchPopup()
      // },
      {
        label: 'Check Your Fitment',
        show: this.hasFitmentData && this.vehicleName
      },
      {
        label: 'Questions',
        show: true
      }
    ].filter(l => l.show);
  }

  handleClick(item: any) {
  switch (item.label) {
    case 'Specifications':
      this.scrollTo('specification');
      break;
    case 'Applications':
      this.scrollTo('applications');
      break;
    case 'Check Fitment':
      this.openVechicleSearchPopup();
      break;
    case 'Check Your Fitment':
      this.scrollTo('fitment');
      break;
    case 'Questions':
      this.onClickQuestions();
      break;
  }
}

  isShipsToday(): boolean {
    const now = new Date();
    const estTime = new Date(
      now.toLocaleString("en-US", { timeZone: "America/New_York" })
    );
    return estTime.getHours() < 15; // before 3 PM EST
  }

 getProductSpecialistContactInfo(): void {
    if (this.browser.isBrowser) {
      const footerData = this.browser.localStorage?.getItem('footerData');
      if (footerData) {
        const footer = JSON.parse(footerData);
        this.productSpecialistContactInfo = footer?.contactDetails[0]?.product_specialist_contact_info;
        return;
      }
    }
    this.footerHttp.footerList().subscribe({
      next: (response) => {
        const footer = response?.[this.firstObj]?.data;
        if (!footer) {
          return;
        }
        this.productSpecialistContactInfo = footer?.contactDetails[0]?.product_specialist_contact_info;
      },
      error: (error) => {
        console.error('Error while fetching footer data', error);
      },
    });
  }

  openProductAdmin(productKey: number | string): void {
    const adminUrl = `${this.merchantProductUrl}${productKey}`;
    this.browser.window?.open(adminUrl, '_blank');
  }

  ngOnDestroy() {
    if (this.scrollHandler) {
      this.browser.window?.removeEventListener('scroll', this.scrollHandler);
    }
    if (this.stickyObserver) {
      this.stickyObserver.disconnect();
    }
    if (this.observer) {
      this.observer?.disconnect();
    }
  }
}